







































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';

@Component
export default class AddAsinInfo extends Vue {
  private user: any;
  private isAdd: boolean = true;
  private account: string = '';
  private team: string = 'gsk';
  private productStatus: string = '新产品';
  private productTitle: string = '';
  private productPeople: string = '';
  private sku: string = '';
  private asin: string = '';
  private brand: string = '';
  private spinning: boolean = false;
  // tslint:disable-next-line:max-line-length
  private productStatusJson: any = [{status: '新产品' }, {status: '临时点' }, {status: '继续推进' }, {status: '稳定长期' }, {status: '清理库存' }];
  private pagination: any = {
    hideOnSinglePage: false,
    pageSize: 30, // 默认每页显示数量
    pageSizeOptions: ['100', '200', '300', '400'], // 每页数量选项
    showSizeChanger: true, // 显示可改变每页数量
    showTotal: (total: any) => `Total ${total} items`, // 显示总数
  };
  private columns: any = [{
    title: 'Id',
    dataIndex: 'id',
    width: '8%',
    scopedSlots: { customRender: 'Id' },
  }, {
    title: 'Account',
    dataIndex: 'account',
    width: '15%',
    scopedSlots: { customRender: 'Account' },
  }, {
    title: 'Team',
    dataIndex: 'team',
    width: '15%',
    scopedSlots: { customRender: 'Team' },
  },
  {
    title: 'sku',
    dataIndex: 'sku',
    width: '25%',
    scopedSlots: { customRender: 'sku' },
  },
  {
    title: 'Asin',
    dataIndex: 'asin',
    width: '15%',
    scopedSlots: { customRender: 'Asin' },
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    // width: '15%',
    scopedSlots: { customRender: 'brand' },
  }];
  private searchText: string = '';
  private searchInput: any;
  private dataJson: any = [];
  private teamJson: any = [];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getData();
      this.getTeam();
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private rankingtypeChange(value: string): void {
    this.team = value;
  }
  private rankingtypeChange2(value: string): void {
    this.productStatus = value;
  }
  private async getData() {
    this.spinning = true;
    const url: string = '/api/getALLAsin';
    const args = {
      team: this.user.team,
    };
    // console.log(args);
    const data = await this.axios.post(url, args);
    this.dataJson = this.dataJson.splice(0, this.dataJson.length);
    if (data.data.code === 12 ) {
      this.dataJson = data.data.data;
    }
    this.spinning = false;
  }
  private saveAccount(): any {
    // tslint:disable-next-line:max-line-length
    if (this.account === '' || this.sku === '' || this.asin === '' || this.asin === ''  || this.brand === '' || this.productStatus === '' || this.productTitle === '' || this.productPeople === '') {
      this.$message.error('not empty!!!');
      return false;
    }
    this.spinning = true;
    const url: string = '/api/saveAccount';
    const args = {
      account: this.account.trim(),
      team: this.team,
      sku: this.sku.trim(),
      asin: this.asin.trim(),
      brand: this.brand.trim(),
      productStatus: this.productStatus.trim(),
      title: this.productTitle.trim(),
      people: this.productPeople.trim(),
    };
    this.axios.post(url, args).then((res) => {
      if (res.data.code === 12 ) {
        this.getData();
        this.account = '';
        this.sku = '';
        this.asin = '';
        this.productStatus = '';
        this.productTitle = '';
        this.productPeople = '';
        this.isAdd = true;
      } else if (res.data.code === 9 ) {
        this.$message.error(res.data.msg.sqlMessage);
      }
      this.spinning = false;
    }).catch((err) => {
      console.log(err);
      this.$message.error('error  ' + err);
      this.spinning = false;
    });
  }
  private async getTeam() {
    const that = this;
    // this.accountJson.splice(0, that.accountJson.length);
    // this.spinning = true;
    const url: string = '/api/getTeam';
    const args = {};
    const data = await this.axios.post(url, args);
    if (data.data.code === 12) {
      this.teamJson = data.data.data;
    }
  }
  private addAccountFun() {
    this.isAdd = false;
  }
}
